import React from 'react';
import { Clock, CheckCircle, Shield } from 'lucide-react';

const benefits = [
  {
    icon: <Clock className="w-6 h-6" />,
    title: 'Save Time and Effort',
    description: 'Create a professional resume in minutes, not hours'
  },
  {
    icon: <CheckCircle className="w-6 h-6" />,
    title: 'Industry-Standard Templates',
    description: 'ATS-friendly designs that get past resume scanners'
  },
  {
    icon: <Shield className="w-6 h-6" />,
    title: 'Perfect Formatting',
    description: 'AI ensures consistent and error-free formatting'
  }
];

export default function WhyChooseUs() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Why Choose Us
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 mx-auto bg-indigo-100 rounded-full flex 
                items-center justify-center text-indigo-600 mb-4">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}